import request from '@/utils/request'

export function signupMSMA(email, password, companyname, appInterested, ciInterested) {
  return request({
    url: '/auth/local/register',
    method: 'post',
    data: {
      email: email,
      password: password,
      feature: 'msma',
      role: 'User',
      companyname: companyname,
      appInterested: appInterested,
      ciInterested: ciInterested
    }
  })
}

export function registerMSMA() {
  return request({
    url: '/msma/user/register',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/signup.js